import React, { useState, useEffect, forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  Box,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import ReservaViaje from '../ReservaFrom';
import Reserva from '../Reserva';

// Copiado para la cancelacion. Cuando se unifique se puedne eliminar
import api from '../../helpers/api';
import Swal from 'sweetalert2';
import moment from 'moment';

import {
  refrescarUltimasAutorizaciones,
  addAutorizacionesSolitudAction,
} from '../../redux/actions/autorizacionActions';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  content: {
    padding: 20,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  button: {
    color: '#ffffff',
  },
  absolute: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(3),
  },
  textCenter: { alignItems: 'center' },
}));

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default ({ open, setOpen }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { solicitudID } = useSelector((state) => state.autorizaciones);

  const listado = useSelector((state) =>
    state.autorizaciones.listado.filter((l) => l.solicitudId === solicitudID)
  );

  const { token, esencialCC } = useSelector((state) => state.auth);

  const [initialStatus] = useState({
    open: listado.length ? false : true,
    tabIndex: 0,
  });

  const handleClose = () => {
    setOpen(false);
    dispatch(addAutorizacionesSolitudAction([]));
  };

  const OnAgregarReserva = (add) => {
    dispatch(refrescarUltimasAutorizaciones(token));
  };

  const handleEnviarReservar = () => {
    dispatch(addAutorizacionesSolitudAction([]));
    // dispatch(refrescarAutorizacionesSolitudAction(token, solicitudID));
    setOpen(false);
  };

  /* EMPIEZO UN COPYPASTE DE AUTORIZACIONES PARA LA CANCELACION. LUEGO HABRIA QUE UNIFICAR */
  const [reserva, setReserva] = useState(null);

  const onCancelar = (reserva) => {
    setReserva(reserva);
  };

  useEffect(
    (solicitudID) => {
      const confirmAction = async () => {
        try {
          const response = await api.delete(`v1/autorizaciones/${reserva.id}`, {
            headers: {
              Authorization: token,
            },
          });

          dispatch(refrescarUltimasAutorizaciones(token));

          if (response.data.code === 200) {
            Swal.fire({
              title: 'Viaje cancelado',
              text: `Tu viaje ha sido cancelado`,
              icon: 'success',
              allowOutsideClick: true,
              confirmButtonText: 'Aceptar',
            });
          } else {
            Swal.fire({
              title: 'Error',
              text: `No pudimos cancelar tu viaje en este momento`,
              icon: 'danger',
              allowOutsideClick: true,
              confirmButtonText: 'Aceptar',
            });
          }
        } catch (ex) {
          Swal.fire({
            title: 'Error',
            text: `No pudimos cancelar tu viaje en este momento`,
            icon: 'danger',
            allowOutsideClick: true,
            confirmButtonText: 'Aceptar',
          });
        }
      };
      if (reserva !== null) {
        Swal.fire({
          title: '¿Querés cancelar tu viaje?',
          text: `Se cancelará tu viaje ${reserva.servicio.numero} del ${moment(
            reserva.servicio.fecha
          ).format('DD/MM/YYYY')}`,
          icon: 'warning',
          showCancelButton: true,
          allowOutsideClick: false,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Si, cancelar',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.value) {
            confirmAction(reserva);
          }
          setReserva(null);
        });
      }
    },
    [reserva, token, dispatch]
  );

  /* FIN COPYPASTE */

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              onClick={handleClose}
              aria-label='close'
            >
              <CloseIcon />
            </IconButton>
            <Typography variant='h6' className={classes.title}>
              Reservas
            </Typography>
            {listado.length === 0 ? (
              ''
            ) : (
              <Button
                variant='contained'
                color='secondary'
                className={classes.button}
                endIcon={<CloseIcon />}
                onClick={handleEnviarReservar}
              >
                Cerrar
              </Button>
            )}
          </Toolbar>
        </AppBar>
        <Box className={classes.content}>
          {listado.length === 0 ? (
            <h2>Crea tu reserva</h2>
          ) : (
            <>
              <h2>Reservas generadas</h2>
              <Grid container spacing={3}>
                {listado.map((r) => (
                  <Grid item md={3} xs={12} className={classes.textCenter}>
                    <Reserva
                      key={r.id}
                      reserva={r}
                      modoEdicion={false}
                      onCancelarReserva={onCancelar}
                      btnDuplicar={true}
                    />
                  </Grid>
                ))}
              </Grid>
            </>
          )}
          {esencialCC && (
            <ReservaViaje
              OnAgregarReserva={OnAgregarReserva}
              initialStatusOpen={initialStatus}
            />
          )}
        </Box>
      </Dialog>
    </>
  );
};
